/*
-----------------------------------------
Scss
-----------------------------------------
*/

import '@components/main.scss';

/*
-----------------------------------------
Modules
-----------------------------------------
*/

// Jquery
const $   = require('jquery');
const csv = require('jquery-csv');

// DataTables
const DataTable = require('datatables.net');
require('datatables.net-fixedcolumns-dt');

// Iframe Resizer
require('iframe-resizer/js/iframeResizer.contentWindow');

/*
-----------------------------------------
DataTable
-----------------------------------------
*/

function createTable(table, header, columns, sort)
{
	let cols = [];
	let startKeyFigures = 3;
	// top 500
	if (typeof(header[6]) === "undefined") {
		cols = [
			{title: '<span>' + header[0] + '</span>', data: columns[0], className: "index", width: "1%", type: "num"},
			{title: '<span>' + header[1] + '</span>', data: columns[1], className: "company"},
			{title: '<span>' + header[2] + '</span>', data: columns[2], className: "country"},
		];
	// child rankings
	} else {
		cols = [
			{title: '<span>' + header[0] + '</span>', data: columns[0], className: "index", width: "1%", type: "num"},
			{title: '<span>' + header[1] + '</span>', data: columns[1], className: "previous", width: "1%", type: "num"},
			{title: '<span>' + header[2] + '</span>', data: columns[2], className: "company"},
			{title: '<span>' + header[3] + '</span>', data: columns[3], className: "activity"},
			{title: '<span>' + header[4] + '</span>', data: columns[4], className: "country"},
		];
		startKeyFigures = 5;
	}

	for(let i = startKeyFigures; i < 10; i++) {
		if (typeof(header[i]) === "undefined") {
			break;
		}
		cols.push({ title: '<span>' + header[i] + '</span>', data: columns[i], className: "keyfigures", width: "1%", type: "num"});
	}

	const csvTable = new DataTable(table, {
		pageLength: 20,
		lengthChange: false,
		searching: false,
		info: false,
		scrollX: true,
		scrollCollapse: false,
		autoWidth: true,
		fixedColumns: true,
		language: {
			paginate: {
				previous: "<i class='icon icon-arrow-left'></i>",
				next: "<i class='icon icon-arrow-right'></i>",
			}
		},
		columns: cols,
		order: [
			[ 0, sort ]
		],
	});

	return csvTable;
}

/*
-----------------------------------------
Init
-----------------------------------------
*/

jQuery(function() {
	// Get cvs data from data-src attribute
	const table = $('#ranking'),
				dataSrc = table.data('src'),
				dataHeader = table.data('header').replace(/\[|\]/g,'').split(','),
				dataSort = table.data('sort');

	// Remove table data attributes after retrieving data
	table.removeAttr('data-src').removeAttr('data-header');

	$.ajax({
		type: "GET",
		url: dataSrc,
		// url: "../data/full.csv", // Local testing data
		dataType: "text",
		success: function(data) {
			const csvRows = $.csv.toObjects(data),
						csvCols = Object.keys(csvRows[0]),
						tableCols = [];

			// Import columns from csv file
			for (const key in csvCols) {
				tableCols.push(csvCols[key]);
			};

			// Check if progress is positive/negative when there is a sixth column (for progression since last ranking)
			// if(tableCols[6]) {
			// 	const progressID = tableCols[6];
			//
			// 	for (const key in csvRows) {
			// 		if (csvRows[key][progressID]) {
			// 			let progressClass = '';
			//
			// 			// If value is positive
			// 			if (csvRows[key][progressID] > 0) {
			// 				progressClass = 'is-positive';
			// 				csvRows[key][progressID] = '+' + csvRows[key][progressID]; // Add '+' before number
			// 			}
			// 			// If value is negative
			// 			if (csvRows[key][progressID] < 0) {
			// 				progressClass = 'is-negative';
			// 			}
			// 			// If value is zero
			// 			if (csvRows[key][progressID] == 0) {
			// 				progressClass = 'is-zero';
			// 			}
			//
			// 			// Wrap value inside a span
			// 			csvRows[key][progressID] = '<span class="' + progressClass + '">' + csvRows[key][progressID] + '</span>';
			// 		}
			// 	}
			// }

			// Init Table
			const csvTable = createTable(table, dataHeader, tableCols, dataSort);

			// Inject Data rows
			csvTable.rows.add(csvRows).draw();
		}
	});
});
